import { useModel as _useModel, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "add-new-option-container" };
import { ref, computed, h } from "vue";
import { useStore } from "@/store";
import CustomSVG from "@/components/custom/CustomSVG.vue";
import { NButton, NIcon, NInput } from "naive-ui";
import api from "@/utils/api";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CategorySelector',
    props: {
        "bindValue": {
            type: [String, null],
            default: null,
        },
        "bindValueModifiers": {},
    },
    emits: ["update:bindValue"],
    setup: function (__props) {
        var store = useStore();
        // const emit = defineEmits(["update:bind-value"]);
        // const props = defineProps({
        //   bindValue: [String, null] as PropType<String | null>,
        // });
        // watch(
        //   () => selectedCategory.value,
        //   (newValue) => {
        //     // 当 bindValue 发生变化时，触发 update:bind-value 事件
        //     console.log("Category Selector ModelValue Changed", newValue);
        //     emit("update:bind-value", newValue); // 双向绑定受控，发送事件使得传来的值能发生变化
        //   }
        // );
        // const selectedCategory = ref<string | null>(props.bindValue as string | null);
        var selectedCategory = _useModel(__props, "bindValue");
        var newCategoryInput = ref("");
        var categoryOptions = ref([]);
        api.requestWithoutMask.get("/categorylist").then(function (res) {
            categoryOptions.value = res.data;
        });
        var categoryRenderOptions = computed(function () {
            return categoryOptions.value.map(function (item) {
                return {
                    label: item,
                    value: item,
                };
            });
        });
        var addNewCategory = function () {
            if (newCategoryInput.value.trim() === "") {
                window.$message.error("分类不能为空");
                return;
            }
            if (categoryOptions.value.includes(newCategoryInput.value)) {
                window.$message.error("分类已存在");
                return;
            }
            api.request
                .quickPost("/addcategory", {
                category: newCategoryInput.value,
            })
                .then(function (res) {
                window.$msgSuccess("添加成功");
                categoryOptions.value.push(newCategoryInput.value);
                selectedCategory.value = newCategoryInput.value;
                newCategoryInput.value = "";
            })
                .catch(function (err) {
                window.$message.error("添加失败");
            });
        };
        var deleteOption = function (category) {
            api.request
                .quickPost("/deletecategory", {
                category: category,
            })
                .then(function (res) {
                var index = categoryOptions.value.indexOf(category);
                if (index > -1) {
                    categoryOptions.value.splice(index, 1);
                    window.$message.success("删除成功");
                }
                else {
                    window.$message.error("列表出错");
                    return;
                }
                if (selectedCategory.value === category) {
                    selectedCategory.value = null;
                }
            })
                .catch(function (err) {
                var resp = err.response;
                window.$notifyError("删除失败", resp.msg);
            });
        };
        var isModifyOption = ref(false), modifyContent = ref(""), needSwitchInputOption = ref("");
        var setModifyOption = function (option) {
            modifyContent.value = option;
            needSwitchInputOption.value = option;
            isModifyOption.value = true;
        };
        var confirmModifyoption = function () {
            api.request
                .quickPost("/modifycategory", {
                oldValue: needSwitchInputOption.value,
                newValue: modifyContent.value,
            })
                .then(function (res) {
                var index = categoryOptions.value.indexOf(needSwitchInputOption.value);
                if (index > -1) {
                    categoryOptions.value[index] = modifyContent.value;
                    window.$message.success("修改成功");
                }
                else {
                    window.$message.error("列表出错");
                    return;
                }
                if (selectedCategory.value === needSwitchInputOption.value) {
                    selectedCategory.value = modifyContent.value;
                }
            })
                .catch(function (err) {
                var resp = err.response;
                window.$notifyError("修改失败", resp.msg);
            })
                .finally(function () {
                isModifyOption.value = false;
                needSwitchInputOption.value = "";
            });
        };
        var renderLabel = function (option) {
            return [
                h("div", {
                    class: "select-option-container",
                }, {
                    default: function () { return [
                        h("span", {
                            class: "option-label",
                            style: isModifyOption.value &&
                                needSwitchInputOption.value === option.label
                                ? { display: "none" }
                                : {},
                        }, option.label),
                        h(NInput, {
                            class: "option-modify-input",
                            style: !(isModifyOption.value &&
                                needSwitchInputOption.value === option.label)
                                ? { display: "none" }
                                : {},
                            value: modifyContent.value,
                            "onUpdate:value": function (val) { return (modifyContent.value = val); },
                            onClick: function (e) { return e.stopPropagation(); },
                            onMousedown: function (e) { return e.stopPropagation(); },
                            onMouseup: function (e) { return e.stopPropagation(); },
                        }),
                        h("div", {
                            class: "select-option-btn-group",
                        }, {
                            default: function () { return [
                                h(NButton, {
                                    class: "select-delete-option-btn",
                                    size: "small",
                                    onClick: function (e) {
                                        e.stopPropagation();
                                        setModifyOption(option.label);
                                    },
                                    style: isModifyOption.value &&
                                        needSwitchInputOption.value === option.label
                                        ? { display: "none" }
                                        : {},
                                }, {
                                    icon: function () {
                                        return h(NIcon, { size: "1.2rem" }, function () {
                                            return h(CustomSVG, {
                                                icon: "Edit",
                                                class: "delete-option-icon",
                                            });
                                        });
                                    },
                                }),
                                h(NButton, {
                                    class: "select-delete-option-btn",
                                    size: "small",
                                    onClick: function (e) {
                                        e.stopPropagation();
                                        confirmModifyoption();
                                    },
                                    style: !(isModifyOption.value &&
                                        needSwitchInputOption.value === option.label)
                                        ? { display: "none" }
                                        : {},
                                }, {
                                    icon: function () {
                                        return h(NIcon, { size: "1.2rem" }, function () {
                                            return h(CustomSVG, {
                                                icon: "Check",
                                                class: "delete-option-icon",
                                            });
                                        });
                                    },
                                }),
                                h(NButton, {
                                    class: "select-delete-option-btn",
                                    size: "small",
                                    onClick: function (e) {
                                        e.stopPropagation();
                                        deleteOption(option.label);
                                    },
                                }, {
                                    icon: function () {
                                        return h(NIcon, { size: "1.2rem" }, function () {
                                            return h(CustomSVG, {
                                                icon: "Delete24Filled",
                                                class: "delete-option-icon",
                                            });
                                        });
                                    },
                                }),
                            ]; },
                        }),
                    ]; },
                }),
            ];
        };
        return function (_ctx, _cache) {
            var _component_n_select = _resolveComponent("n-select");
            return (_openBlock(), _createBlock(_component_n_select, {
                value: selectedCategory.value,
                "onUpdate:value": _cache[1] || (_cache[1] = function ($event) { return ((selectedCategory).value = $event); }),
                options: categoryRenderOptions.value,
                filterable: true,
                placeholder: "选择分类（可输入过滤）",
                "render-label": renderLabel,
                "onUpdate:show": _cache[2] || (_cache[2] = function ($event) { return (isModifyOption.value = false); })
            }, {
                header: _withCtx(function () { return [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_unref(NInput), {
                            value: newCategoryInput.value,
                            "onUpdate:value": _cache[0] || (_cache[0] = function ($event) { return ((newCategoryInput).value = $event); }),
                            placeholder: "添加新分类"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(NButton), {
                            onClick: addNewCategory,
                            size: "small",
                            type: "primary",
                            class: "add-new-option-button"
                        }, {
                            icon: _withCtx(function () { return [
                                _createVNode(_unref(NIcon), null, {
                                    default: _withCtx(function () { return [
                                        _createVNode(CustomSVG, {
                                            icon: "Check",
                                            class: "add-option-btn-icon"
                                        })
                                    ]; }),
                                    _: 1
                                })
                            ]; }),
                            _: 1
                        })
                    ])
                ]; }),
                _: 1
            }, 8, ["value", "options"]));
        };
    }
});
